import { useAwardPoints } from "../../hooks/useAwardPoints";

const VideoWatched = ({ achievementId, collection, id, allowDuplicates = false, validityCheck = true, showModalOverride, userPayload={} }) => {
    useAwardPoints(achievementId, collection, id, allowDuplicates, validityCheck,  showModalOverride, userPayload);

    return null;
}

export default VideoWatched;